import { HeaderTestIds } from '@trello/test-ids';
import { InformationIcon } from '@trello/nachos/icons/information';
import React, { Suspense, FunctionComponent, useCallback } from 'react';
import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';
import { usePopover, Popover } from '@trello/nachos/popover';
import { forNamespace, forTemplate } from 'app/common/lib/util/i18n';
import { useLazyComponent } from '@trello/use-lazy-component';
const viewTitle = forNamespace('view title');

export const InfoMenuButton: FunctionComponent = () => {
  const HeaderInfoMenuPopover = useLazyComponent(() =>
    import(
      /* webpackChunkName: "info-menu-popover" */ 'app/gamma/src/components/popovers/header-info-menu'
    ),
  );

  const { toggle, triggerRef, popoverProps } = usePopover<HTMLButtonElement>();

  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.INFO_MENU,
      method: 'clicking info header button',
    });
    toggle();
  }, [toggle]);

  return (
    <>
      <HeaderButton
        icon={<InformationIcon color="light" />}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.InfoButton}
        ariaLabel={forTemplate('header_user')('open-information-menu')}
      />
      <Popover {...popoverProps} title={viewTitle('information')} size="large">
        <Suspense fallback={null}>
          <HeaderInfoMenuPopover />
        </Suspense>
      </Popover>
    </>
  );
};
